<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="funcionarios"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters
            :filters="filters"
            v-model="filtrosAtivos"
          ></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-btn
            v-if="perms.includes('funcionario.criar_funcionario')"
            depressed
            color="accent"
            :to="{ name: 'funcionario-formulario' }"
          >
            <v-icon class="mdi mdi-account-plus mr-2" />Novo Cadastro
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.telefone="{ item }">{{
        telefone(item.telefone)
      }}</template>
      <template v-slot:item.actions="{ item }">
        <lista-documentos-dialog
          :title="`Documentos de ${item.nome}`"
          :id-proprietario="item.id"
          url-base="funcionarios"
        />
        <v-btn
          v-if="perms.includes('funcionario.editar_funcionario')"
          icon
          small
          text
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          v-if="perms.includes('funcionario.excluir_funcionario')"
          titulo="Deletar Funcionário"
          texto="Confirma a exclusão?"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DatatableFilters from "../components/DatatableFilters";
import DialogConfirm from "../components/DialogConfirm";
import ListaDocumentosDialog from "../components/documentos/ListaDocumentosDialog";
import { build } from "../lib/masks";
export default {
  components: { DatatableFilters, DialogConfirm, ListaDocumentosDialog },
  data() {
    return {
      headers: [
        { text: "Empresa", value: "empresa.nome_fantasia", align: "center" },
        { text: "Matrícula", value: "matricula", align: "center" },
        { text: "Nome", value: "nome" },
        { text: "E-mail", value: "email" },
        { text: "Telefone", value: "telefone" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      filters: [
        {
          name: "id_empresa",
          label: "Empresa",
          type: "select",
          options: [],
        },
        {
          name: "matricula",
          label: "Matrícula",
          type: "number",
          defaultValue: "",
        },
        {
          name: "nome",
          label: "Nome",
          type: "text",
          defaultValue: "",
        },
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.funcionarios") || `{}`
      ),
      loading: false,
      dialogConfirm: false,
    };
  },
  computed: mapState({
    funcionarios: (state) => state.funcionario.Funcionarios,
    empresas: (state) => state.empresa.empresas,
    perms: (state) => state.usuarios.usuarioAtivo.permissoes,
  }),
  methods: {
    async deletar(id) {
      this.loading = true;
      await this.$store.dispatch("funcionario/deletar", { id });

      this.listar();
    },
    editar(id) {
      this.$router.replace({
        path: "editar",
        name: "funcionario-formulario-editar",
        params: { id },
      });
    },
    async listar() {
      this.loading = true;
      try {
        await this.$store.dispatch("funcionario/listar", this.filtrosAtivos);
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    telefone(val) {
      return build.phone(val);
    },
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.funcionarios", JSON.stringify(val));
      this.listar();
    },
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de funcionários",
    });
    this.loading = true;
    this.$store.dispatch("empresa/listar", {}).then((empresas) => {
      this.filters.find(
        (f) => f.name === "id_empresa"
      ).options = empresas.data.map((e) => ({
        text: e.nome_fantasia,
        value: e.id,
      }));
    });
    this.listar();
    this.loading = false;
  },
};
</script>
